var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1454.556,
    height: 468.758,
    viewBox: "0 0 1454.556 468.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(-24.472 -5089.478)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M119.425,129.377,79.617,0,0,91.228Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 80.091, 5193.93)",
    fill: "#aaa9a9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M117.766,79.617,79.617,0,0,41.467Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 352.771, 5291.512)",
    fill: "#777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M79.617,76.3,61.371,0,0,28.2Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 426.001, 5392.06)",
    fill: "#aaa9a9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M18.246,0,1.659,33.174,0,3.317Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 358.046, 5389.933)",
    fill: "#777"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M24.051,8.293,16.587,34,0,0Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 724.661, 5247.198)",
    fill: "#777"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M26.539,13.269,0,0,14.928,34.832Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 281.907, 5277.978)",
    fill: "#777"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M114.449,15.758,0,83.763,29.856,0Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 91.876, 5408.898)",
    fill: "#aaa9a9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M106.985,39.808,43.955,82.934,0,0Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 24.472, 5337.541)",
    fill: "#d3d3d3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M58.883,54.737,29.027,0,0,97.862Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 28.756, 5454.469)",
    fill: "#777"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M24.051,4.976,18.246,23.222,0,0Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 59.811, 5403.562)",
    fill: "#777"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M81.276,38.15,53.078,0,0,43.955Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 740.276, 5480.422)",
    fill: "#d3d3d3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M14.1,18.246,11.611,0,0,24.051Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 688.53, 5386.27)",
    fill: "#777"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M39.55,0,29.93,45.964,0,48.1Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 631.309, 5428.29)",
    fill: "#777"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M64.688,0,58.054,105.326,0,39.808Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 986.459, 5332.688)",
    fill: "#777"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M128.548,116.937,0,56.4,100.35,0Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 815.924, 5292.875)",
    fill: "#777"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M121.734,107.865,26.2,0,0,132.52Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 614.453, 5316.956)",
    fill: "#d3d3d3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M43.126,12.44,0,0,14.1,65.518Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 923.975, 5465.557)",
    fill: "#777"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M92.886,0,75.47,153.428,0,63.859Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 1281.503, 5376.008)",
    fill: "#d3d3d3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M7.333,0,49.5,28.416,0,87.081Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 1040.417, 5391.961)",
    fill: "#aaa9a9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M24.88,20.734,39.809,0,0,4.147Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 870.583, 5366.928)",
    fill: "#777"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M16.587,7.464l-5.806,24.88L0,0Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 507.941, 5191.333)",
    fill: "#777"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M14.928,9.123,1.659,0,0,34.832Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 1170.156, 5430.771)",
    fill: "#777"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M87.081,35.662,0,0,73.811,131.036Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 1322.204, 5494.709)",
    fill: "#777"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M29.856,0,0,5.805,19.9,35.662Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 542.423, 5426.49)",
    fill: "#777"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.786c93c408cba489db02e731220077fc.svg";
export { ForwardRef as ReactComponent };